var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThunder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 233,
    viewBox: "0 0 227 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.949 119.739L104.851 78.4885L151.995 23.1458L181.227 41.833L142.839 76.4012L180.662 126.952L72.27 186.791L135.949 119.739Z",
    fill: "#FDEB7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.451 116.162L92.3528 74.9112L139.497 19.5685L168.729 38.2557L130.34 72.8239L168.164 123.375L59.7719 183.213L123.451 116.162Z",
    fill: "#FDEB7A",
    stroke: "black",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5621 104.761L40.4037 33.0006L80.6845 34.6673L50.3183 108.292L28.5621 104.761Z",
    fill: "#FFE3BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6261 115.898L22.036 113.364L30.3482 41.5098L69.6585 41.7467L42.6261 115.898Z",
    fill: "#FFE3BF",
    stroke: "black",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.5d0238168bc5d3261705b41be4c2cbae.svg";
export { ForwardRef as ReactComponent };